import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "@phosphor-icons/react";
import { CATEGORIES, categoryLabel } from "../lib/api";
import BudgetAmountControl from "./BudgetAmountControl";

export default function BudgetModule({ surface = "home" }) {
  const navigate = useNavigate();
  const [budget, setBudget] = useState(20);
  const [category, setCategory] = useState("all");
  const budgetControlRef = useRef(null);
  const isCatalogue = surface === "catalogue";

  const go = (e) => {
    e?.preventDefault?.();
    const v = budgetControlRef.current?.commit();
    if (v == null) return;
    const params = new URLSearchParams();
    params.set("budget", String(v));
    if (category !== "all") params.set("category", category);
    navigate(`/best-odds-for-budget?${params.toString()}`);
  };

  return (
    <section
      className={isCatalogue ? "mb-10" : "max-w-7xl mx-auto px-6 lg:px-8 -mt-12 sm:-mt-16 relative z-10"}
      data-testid={isCatalogue ? "catalogue-budget-module" : "homepage-budget-module"}
    >
      <div className={`rounded-lg border border-[var(--cc-gold)]/30 bg-[var(--cc-card-dark)] p-6 sm:p-8 ${isCatalogue ? "" : "shadow-2xl shadow-black/40"}`}>
        <div className="grid lg:grid-cols-[1.2fr_auto] gap-6 items-end">
          <div>
            <div className="overline text-[var(--cc-gold)] mb-2">Budget Odds</div>
            <h2 className="font-display text-2xl sm:text-3xl font-semibold leading-tight">
              {isCatalogue ? "What can your budget get you?" : "How far can your budget really go?"}
            </h2>
            <p className="text-sm text-[var(--cc-text-muted)] mt-2 max-w-xl">
              {isCatalogue
                ? "Enter what you're happy to spend and we'll show you the current UK competitions offering the strongest maximum odds for that budget."
                : "Try our Budget Odds Calculator and compare which current UK competitions offer the best maximum odds for your ticket budget."}
            </p>
            <p className="text-sm text-white font-semibold mt-2">Know what your money truly gets you.</p>
            <form onSubmit={go} className="mt-5 flex flex-col gap-4">
              <BudgetAmountControl
                ref={budgetControlRef}
                budget={budget}
                onBudgetChange={setBudget}
                testIdPrefix={isCatalogue ? "catalogue-" : "home-"}
              />
              {!isCatalogue && <div>
                <div className="overline text-white/40 mb-2">Category</div>
                <div className="flex flex-wrap gap-2">
                  <button
                    type="button"
                    onClick={() => setCategory("all")}
                    data-testid="home-cat-all"
                    className={`px-3 py-1.5 rounded-full text-xs border ${
                      category === "all"
                        ? "bg-white text-[var(--cc-navy)] border-white"
                        : "border-white/15 text-white/70 hover:border-white/35"
                    }`}
                  >
                    All
                  </button>
                  {CATEGORIES.map((c) => (
                    <button
                      type="button"
                      key={c}
                      onClick={() => setCategory(c)}
                      data-testid={`home-cat-${c}`}
                      className={`px-3 py-1.5 rounded-full text-xs border ${
                        category === c
                          ? "bg-white text-[var(--cc-navy)] border-white"
                          : "border-white/15 text-white/70 hover:border-white/35"
                      }`}
                    >
                      {categoryLabel(c)}
                    </button>
                  ))}
                </div>
              </div>}
            </form>
          </div>
          <button
            onClick={go}
            data-testid={isCatalogue ? "catalogue-budget-submit" : "home-budget-submit"}
            className="btn-gold px-6 py-4 rounded inline-flex items-center justify-center gap-2 lg:w-auto w-full text-sm font-semibold"
          >
            {isCatalogue ? "Find my best odds" : "Try the Budget Odds Calculator"} <ArrowRight size={16} weight="bold" />
          </button>
        </div>
      </div>
    </section>
  );
}
